export const ROUTES = {
    // auth
    signIn: '/iniciar-sesion',
    signInTest: '/iniciar-sesion-prueba',
    signUp: '/registrarse',
    signUpEmailConfirm: '/registrarse/confirmar-email',
    reactivate: '/reactivar',
    forgotPassword: '/recuperar-contrasena',
    emailVerify: '/verificar_email',
    guestSignUp: '/aceptar_invitacion',
    // onboarding
    onboarding: '/bienvenido',
    // select workspace
    selectWorkspace: '/seleccionar-espacio-de-trabajo',
    // app
    providers: '/bancos',
    providersHealth: '/bancos/estado',
    history: '/historial',
    alerts: '/alertas',
    automations: '/transacciones/reglas',
    historical: '/historial',
    search: '/transacciones',
    callbackNordigen: '/callbacks/nordigen',
    callbackIndexaCapital: '/callbacks/indexa_capital',
    dashboards: '/paneles',
    reports: '/informes',
    callbackGoogle: '/callbacks/google',
    categories: '/etiquetas',
    invoices: '/facturas',
    invoicesCalendar: '/facturas/calendario',
    invoicesAdd: '/facturas/anadir',
    invoicesIssue: '/facturas/emitir',
    invoicesEdit: '/facturas/editar',
    invoicesReminders: '/facturas/recordatorios',
    invoicesRemindersNew: '/facturas/recordatorios/nuevo',
    invoicesRemindersEdit: '/facturas/recordatorios/editar',
    contacts: '/contactos',
    settings: '/ajustes',
    settingsPreferences: '/ajustes/preferencias',
    settingsWorkspaces: '/ajustes/espacios-de-trabajo',
    settingsUsers: '/ajustes/usuarios',
    settingsSubscription: '/ajustes/suscripcion',
    settingsSupport: '/ajustes/soporte',
    settingsAccessLogs: '/ajustes/logs-de-acceso',
    settingsVersions: '/ajustes/versiones',
    // legacy: redirects to `providersHealth`, internal integration alert emails link here
    settingsBanksHealth: '/ajustes/estado-bancos',
    profile: '/perfil',
    forecasts: '/escenarios',
    calendar: '/calendario',
    integrations: '/integraciones',
    archive: '/papelera',
    recurrences: '/operaciones',
    recurrencesTemplate: '/operaciones/:recurrenceId/plantilla',
    reconciliation: '/conciliacion',
    tagging: '/etiquetado',
    scanInvoices: '/escaner',
    scanInvoicesValidate: '/escaner/validar',
    // Abre "Por validar" con esa factura enfocada: generatePath(ROUTES.scanInvoicesValidateInvoice, { invoiceId }).
    scanInvoicesValidateInvoice: '/escaner/validar/:invoiceId?',
    taxes: '/impuestos',
    partners: '/partners',
    firstSteps: '/primeros-pasos',
    firstStepsInvoicesUpload: '/primeros-pasos/subir-facturas',
    firstStepsInvoicesIssue: '/primeros-pasos/emitir-facturas',
    firstStepsProvidersConnect: '/primeros-pasos/conectar-bancos',
    archiveTransactions: '/transacciones/papelera',
    versions: '/versiones',
    // others
    landing: 'https://banktrack.com/',
    joinInvoicesIssuance: 'https://share-eu1.hsforms.com/1-_6KjGEsSFON1awDjOfCpw2e98n3',
};

export const LEGAL_ROUTES = {
    privacy: {
        ES: 'https://banktrack.com/privacidad',
        EN: 'https://banktrack.com/en/privacy-policy',
    },
    terms: {
        ES: 'https://banktrack.com/condiciones-de-uso',
        EN: 'https://banktrack.com/en/terms-and-conditions',
    },
    affiliateTerms: {
        ES: 'https://banktrack.com/condiciones-de-afiliacion',
        EN: 'https://banktrack.com/en/affiliate-terms',
    },
};

// Feature flags de PostHog (en staging y desarrollo siempre están activos, ver Hooks/useFeatureFlag).
export const FEATURE_FLAGS = {
    INVOICE_REMINDERS: 'invoice_reminders',
    GMAIL_INTEGRATION: 'gmail_integration',
};

export const ROUTES_WITH_SUBROUTES = [ROUTES.dashboards, ROUTES.forecasts, ROUTES.recurrences, ROUTES.settings];

export const SEARCH_FILTERS = {
    INVOICES_MODE: {
        ALL: 'all',
        ONLY_WITH_INVOICES: 'only_with_invoices',
        ONLY_WITHOUT_INVOICES: 'only_without_invoices',
    },
    FILES_MODE: {
        ALL: 'all',
        ONLY_WITH_FILES: 'only_with_files',
        ONLY_WITHOUT_FILES: 'only_without_files',
    },
    IGNORED_MODE: {
        ALL: 'all',
        ONLY_IGNORED: 'only_ignored',
        ONLY_NOT_IGNORED: 'only_not_ignored',
    },
    REVERSED_SIGN_MODE: {
        ALL: 'all',
        ONLY_REVERSED_SIGN: 'only_reversed_sign',
        ONLY_NOT_REVERSED_SIGN: 'only_not_reversed_sign',
    },
    SPLIT_MODE: {
        ALL: 'all',
        ONLY_SPLIT: 'only_split',
        ONLY_NOT_SPLIT: 'only_not_split',
    },
    RECONCILIATION_MODE: {
        ALL: 'all',
        ONLY_RECONCILED: 'only_reconciled',
        ONLY_NOT_RECONCILED: 'only_not_reconciled',
    },
    DATE_TYPE: {
        DATE_BOOKED: 'date_booked',
        DATE_EXECUTED: 'date_executed',
    },
};

export const SEARCH_FILTERS_INVOICES = {
    ISSUED_MODE: {
        ALL: 'all',
        ONLY_ISSUED: 'only_issued',
        ONLY_NOT_ISSUED: 'only_not_issued',
    },
    ACCOUNTING_DELIVERED_MODE: {
        ALL: 'all',
        ONLY_DELIVERED: 'only_delivered',
        ONLY_NOT_DELIVERED: 'only_not_delivered',
    },
    IMPORTED_MODE: {
        ALL: 'all',
        ONLY_IMPORTED: 'only_imported',
        ONLY_NOT_IMPORTED: 'only_not_imported',
    },
    CANCELLED_MODE: {
        ALL: 'all',
        ONLY_CANCELLED: 'only_cancelled',
        ONLY_NOT_CANCELLED: 'only_not_cancelled',
    },
};

export const VIDEOS_TOOLS = {
    dashboards: 'https://www.youtube.com/embed/oZJCmJp4YDA',
    alerts: 'https://www.youtube.com/embed/VpkUt9niWms',
    automations: 'https://www.youtube.com/embed/t_RbNALwb-c',
    reports: 'https://www.youtube.com/embed/e_nKxRGdG00',
    welcome: 'https://www.youtube.com/embed/d16ytuKTjkU',
};

export const UNCATEGORIZED_CATEGORY = { id: 'untagged', label: 'Sin categoría', color: '#787878' };
export const CUSTOM_PERIOD = 'custom';
export const All_TIME_PERIOD = 'all_time';

export const PERIODS = [
    {
        label: 'Hoy',
        i18n: 'periods.today',
        value: 'this_day',
    },
    {
        label: 'Ayer',
        i18n: 'periods.yesterday',
        value: 'past_day',
    },
    {
        label: 'Esta semana',
        i18n: 'periods.this-week',
        value: 'this_week',
    },
    {
        label: 'Semana pasada',
        i18n: 'periods.last-week',
        value: 'past_week',
    },
    {
        label: 'Este mes',
        i18n: 'periods.this-month',
        value: 'this_month',
    },
    {
        label: 'Mes pasado',
        i18n: 'periods.last-month',
        value: 'past_month',
    },
    {
        label: 'Este trimestre',
        i18n: 'periods.this-quarter',
        value: 'this_quarter',
    },
    {
        label: 'Trimestre pasado',
        i18n: 'periods.last-quarter',
        value: 'past_quarter',
    },
    {
        label: 'Este año',
        i18n: 'periods.this-year',
        value: 'this_year',
    },
    {
        label: 'Año pasado',
        i18n: 'periods.last-year',
        value: 'past_year',
    },
    {
        label: 'Desde el inicio',
        i18n: 'periods.all-time',
        value: 'all_time',
    },
    {
        label: 'Rango personalizado',
        i18n: 'periods.custom',
        value: CUSTOM_PERIOD,
    },
];

export const INVOICE_TYPES = {
    SALE: 'sale',
    PURCHASE: 'purchase',
};

export const INVOICE_SUBTYPES = {
    STANDARD: 'standard',
    STANDARD_CORRECTIVE: 'standard_corrective',
    SIMPLIFIED: 'simplified',
    SIMPLIFIED_CORRECTIVE: 'simplified_corrective',
    QUOTE: 'quote',
    PROFORMA: 'proforma',
    DELIVERY_NOTE: 'delivery_note',
};

export const ONBOARDING_PLANS = {
    ADVANCED: 'advanced',
    BASIC: 'basic',
    CONSULTING: 'consulting',
};

// Facturas reales: pasan por el ciclo de validación/emisión y son exportables.
export const REAL_INVOICE_SUBTYPES = [
    INVOICE_SUBTYPES.STANDARD,
    INVOICE_SUBTYPES.STANDARD_CORRECTIVE,
    INVOICE_SUBTYPES.SIMPLIFIED,
    INVOICE_SUBTYPES.SIMPLIFIED_CORRECTIVE,
];

// Documentos comerciales: presupuestos, proformas y albaranes. No se exportan.
export const COMMERCIAL_DOCUMENT_SUBTYPES = [
    INVOICE_SUBTYPES.QUOTE,
    INVOICE_SUBTYPES.PROFORMA,
    INVOICE_SUBTYPES.DELIVERY_NOTE,
];

export const INVOICE_LINE_REFERENCE_TYPES = {
    PRODUCT: 'product',
    SERVICE: 'service',
    RESALE: 'resale',
};

export const OPERATIONS_TYPES = {
    CASH_IN: 'cash_in',
    CASH_OUT: 'cash_out',
};

export const INVOICES_CREATION_STATUSES = {
    PENDING_UPLOAD: 'PENDING_UPLOAD',
    PENDING_SCAN: 'PENDING_SCAN',
    PENDING_SCAN_RETRY: 'PENDING_SCAN_RETRY',
    NOT_EMPTY: 'NOT_EMPTY',
    NOT_READABLE: 'NOT_READABLE',
    NOT_SCANNABLE: 'NOT_SCANNABLE',
    NOT_INVOICE: 'NOT_INVOICE',
    ERROR_UPLOAD: 'ERROR_UPLOAD', // Not exists anymore
    ERROR_SCAN: 'ERROR_SCAN', // Not exists anymore
    NO_QUOTA: 'NO_QUOTA',
    OK: 'OK',
};

export const INVOICES_RECONCILED_STATUS = {
    RECONCILED: 'RECONCILED',
    NOT_RECONCILED: 'NOT_RECONCILED',
    NOT_RECONCILED_LATE: 'NOT_RECONCILED_LATE',
};

export const INVOICE_VALID_FORMATS = ['application/pdf', 'image/jpeg', 'image/png', 'image/tiff'];

export const PLANS = {
    FREELANCE_1: 'freelance_1',
    FREELANCE_2: 'freelance_2',
    BUSINESS_1: 'business_1',
    BUSINESS_2: 'business_2',
    BUSINESS_3: 'business_3',
    PERSONAL: 'personal',
    CUSTOM: 'custom',
};

export const FREELANCE_SUBSCRIPTIONS = [PLANS.FREELANCE_1, PLANS.FREELANCE_2];
export const BUSINESS_SUBSCRIPTIONS = [
    PLANS.FREELANCE_1,
    PLANS.FREELANCE_2,
    PLANS.BUSINESS_1,
    PLANS.BUSINESS_2,
    PLANS.BUSINESS_3,
];
export const BUSINESS_PLUS_SUBSCRIPTIONS = [PLANS.BUSINESS_3, PLANS.CUSTOM];
export const STANDARD_SUBSCRIPTIONS = [PLANS.PERSONAL];
export const CURRENT_PLANS = [PLANS.CUSTOM, PLANS.BUSINESS_2, PLANS.BUSINESS_3];
export const PLANS_WITHOUT_SUPPORT = [PLANS.PERSONAL];

export const PROVIDER_CONNECTION_STATUSES = {
    CREATING_PROCESSING: 'CREATING_PROCESSING',
    CREATING_ERROR: 'CREATING_ERROR',
    CREATING_ERROR_FINAL: 'CREATING_ERROR_FINAL',

    RECONNECTING_PROCESSING: 'RECONNECTING_PROCESSING',
    RECONNECTING_ERROR: 'RECONNECTING_ERROR',
    RECONNECTING_SUCCESS: 'RECONNECTING_SUCCESS',

    SYNCHRONIZING: 'SYNCHRONIZING',
    SYNCHRONIZING_ERROR: 'SYNCHRONIZING_ERROR',
    SYNCHRONIZING_ERROR_OTP: 'SYNCHRONIZING_ERROR_OTP',
    SYNCHRONIZING_ERROR_EXPIRED: 'SYNCHRONIZING_ERROR_EXPIRED',

    OK: 'OK',
    EXPIRED: 'EXPIRED',
};

export const CONNECTOR_HEALTH_STATUSES = {
    HEALTHY: 'healthy',
    WITH_PROBLEMS: 'with_problems',
    BROKEN: 'broken',
};

export const COOKIES = {
    FIRST_CONTACT: 'bt-fc',
    LOCALE: 'bt-locale',
    UTM_PARAMS: 'bt-up',
    IDENTIFIED: 'bt-identified',
    LAST_APP_VERSION_RELOADED: 'bt-last-app-version-reloaded',
    AFFILIATE_CODE: 'bt-affiliate-code',
};

export const CONNECTOR_SERVICES = {
    wealth_reader: {
        name: 'Wealth Reader',
        url: 'https://www.wealthreader.com/',
    },
    arcopay: {
        name: 'Arcopay',
        url: 'https://www.arcopay.io/',
    },
    afterbanks_v3: {
        name: 'Arcopay',
        url: 'https://www.arcopay.io/',
    },
    afterbanks_psd2: {
        name: 'Arcopay',
        url: 'https://www.arcopay.io/',
    },
    nordigen: {
        name: 'GoCardLess',
        url: 'https://gocardless.com/',
    },
    indexa_capital: {
        name: 'Indexa Capital',
        url: 'https://indexacapital.com/',
    },
};

export const MODULE_CATEGORIES = {
    LISTS: 'lists',
    TABLES: 'tables',
    CHARTS: 'charts',
    TEXT: 'text',
};

export const CATEGORY_COLORS = [
    '#E04443',
    '#17B686',
    '#FFCF33',
    '#4E74EF',
    '#DE4AB3',
    '#0FB7A5',
    '#844BD6',
    '#FF7F5B',
    '#76AE31',
    '#21BCD0',
    '#C26630',
    '#929292',
    '#292BB2',
    '#8A398F',
    '#46789B',
    '#AB2020',
    '#5A5498',
    '#6F2D21',
];

export const MANUAL_PROVIDER_CONNECTOR_ID = '00YPPccYC3Tw6';

export const REPLAY_BLOCK_CLASS = 'replay-block amp-block';

export const EMPTY_CONTACT_ID = '_empty';

export const RESULTS_PER_PAGE = 20;

export const WHATSAPP_BOT_NUMBER = '+34 629 95 59 67';

export const TELEGRAM_BOT_HANDLE = '@banktrack_bot';

export const DRAWER_STACK = {
    ACCOUNTS_SYNCHRONIZE: 'accounts-synchronize',
    ACCOUNT_EDIT: 'account-edit',
    ACCOUNT_SYNC_HISTORY: 'account-sync-history',
    CALENDAR_INSPECT: 'calendar-inspect',
    CONTACT_EDITOR: 'contact-editor',
    DASHBOARD_ADD_BLOCK: 'dashboard-add-block',
    FORECAST_VALUE: 'forecast-value',
    FORECAST_VALUE_GOAL: 'forecast-value-goal',
    FORECAST_VALUE_IGNORED: 'forecast-value-ignored',
    DASHBOARD_FILTERS: 'dashboard-filters',
    DASHBOARD_SCHEDULE: 'dashboard-schedule',
    DASHBOARD_SCHEDULE_HISTORY: 'dashboard-schedule-history',
    CONTACT_EDITOR_WITH_INVOICE_PREVIEW: 'contact-editor-with-invoice-preview',
    INVOICE_VALIDATION_WITH_RECONCILIATION: 'invoice-validation-with-reconciliation',
    INVOICE_VALIDATION: 'invoice-validation',
    INVOICE_SEND: 'invoice-send',
    INVOICE_DELETE: 'invoice-delete',
    INVOICE_QUICK_EDITOR: 'invoice-quick-editor',
    INVOICE_INVOICING_CONFIG: 'invoice-invoicing-config',
    INVOICE_INVOICING_SERIES: 'invoice-invoicing-series',
    INVOICE_INVOICING_SCANNING: 'invoice-invoicing-scanning',
    INVOICE_INVOICING_TAX_AUTHORITIES: 'invoice-invoicing-tax-authorities',
    INVOICE_INVOICING_DEFAULT_VALUES: 'invoice-invoicing-default-values',
    INVOICE_SERIES_EDITOR: 'invoice-series-editor',
    INVOICE_INVOICING_PAYMENT_METHODS: 'invoice-invoicing-payment-methods',
    INVOICE_PAYMENT_METHODS_EDITOR: 'invoice-payment-methods-editor',
    INVOICE_INVOICING_REFERENCES: 'invoice-invoicing-references',
    INVOICE_CANCEL: 'invoice-cancel',
    INVOICE_CANCEL_WITH_PREVIEW: 'invoice-cancel-with-preview',
    INVOICE_UPLOAD_ERP: 'invoice-upload-erp',
    INVOICE_INBOX: 'invoice-inbox',
    INVOICE_IMPORT: 'invoice-import',
    INVOICE_TAX_AUTHORITY_CONFIG: 'invoice-tax-authority-config',
    INVOICE_TAX_AUTHORITY_CONFIG_CREATE: 'invoice-tax-authority-config-create',
    INVOICE_TAX_AUTHORITY_CONFIG_EDIT: 'invoice-tax-authority-config-edit',
    INVOICE_REMINDERS_DELIVERIES: 'invoice-reminders-deliveries',
    INTEGRATION_EDIT: 'integration-edit',
    REFERENCES_EDITOR: 'references-editor',
    REFERENCES_DELETE: 'references-delete',
    IA_SUGGESTIONS: 'ia-suggestions',
    RECURRENCE_EDITOR: 'recurrence-editor',
    RECURRENCE_EXPECTED_INVOICES: 'recurrence-expected-invoices',
    RECURRENCE_TEMPLATE_CREATE: 'recurrence-template-create',
    RECURRENCE_TEMPLATE_EDIT: 'recurrence-template-edit',
    RECURRENCE_ISSUE_CONFIRM: 'recurrence-issue-confirm',
    CONTACT_MERGE: 'contact-merge',
    TAG_EDITOR: 'tag-editor',
    TAG_EDITOR_WITH_INVOICE_PREVIEW: 'tag-editor-with-invoice-preview',
    SUBTAG_EDITOR: 'subtag-editor',
    TAGS_SELECTOR: 'tags-selector',
    TRANSACTION_EDITOR: 'transaction-editor',
    TRANSACTION_DELETE: 'transaction-delete',
    TRANSACTION_SPLIT_EDITOR: 'transaction-split-editor',
    TRANSACTION_TAGS_EDITOR: 'transaction-tags-editor',
    TRANSACTION_EXPORT: 'transaction-export',
    INVOICE_EXPORT: 'invoice-export',
    CONTACT_EXPORT: 'contact-export',
    TAXES_EXPORT: 'taxes-export',
    SUBSCRIPTION_INVOICES: 'subscription-invoices',
    CONFIRMATION_DIALOG: 'confirmation-dialog',
    DELETE_ITEM: 'delete-item',
    RECONCILIATION_FILTERS_INVOICES: 'reconciliation-filters-invoices',
    RECONCILIATION_FILTERS_TRANSACTIONS: 'reconciliation-filters-transactions',
    SCANNER_REVIEW_FILTERS: 'scanner-review-filters',
    TAXES_CELL_DETAIL: 'taxes-cell-detail',
    CREATE_TRANSACTION: 'create-transaction',
    ADD_MANUAL_PROVIDER: 'add-manual-provider',
    IMPORT_TRANSACTIONS_CSV: 'import-transactions-csv',
    IMPORT_CONTACTS_CSV: 'import-contacts-csv',
    PRODUCT_EDITOR: 'product-editor',
    ADD_PRODUCT: 'add-product',
};

// Modals that open one on top of another, in the same window, with a back button.
export const MODAL_STACK = {
    BANKS_HEALTH_CONNECTOR: 'banks-health-connector',
    BANKS_HEALTH_TICKET: 'banks-health-ticket',
    BANKS_HEALTH_CONFIGURATION: 'banks-health-configuration',
};

export const DIALOG_TYPES = {
    DELETE_CONFIRMATION: 'delete-confirmation',
    CONFIRMATION: 'confirmation',
    RECURRENCE_TEMPLATE_EDITOR: 'recurrence-template-editor',
    DASHBOARD_SCHEDULE_PREVIEW: 'dashboard-schedule-preview',
};

export const DOCUMENTATION_LINKS = {
    IMPORT_TRANSACTIONS: {
        ES: 'https://docs.banktrack.com/es/articles/14717884-importar-transacciones-desde-csv-o-excel',
        EN: 'https://docs.banktrack.com/es/articles/14717884-importar-transacciones-desde-csv-o-excel',
    },
    IMPORT_CONTACTS: {
        ES: 'https://docs.banktrack.com/es/articles/14771318-importar-contactos-desde-csv-o-excel',
        EN: 'https://docs.banktrack.com/es/articles/14771318-importar-contactos-desde-csv-o-excel',
    },
    IMPORT_INVOICES: {
        ES: 'https://docs.banktrack.com/es/articles/14774564-importar-facturas-desde-csv-o-excel',
        EN: 'https://docs.banktrack.com/es/articles/14774564-importar-facturas-desde-csv-o-excel',
    },
    VERIFACTU_DECLARATION: {
        ES: 'https://banktrack.s3.eu-west-1.amazonaws.com/documentos/verifactu_declaracion_responsable_banktrack.pdf',
        EN: 'https://banktrack.s3.eu-west-1.amazonaws.com/documentos/verifactu_declaracion_responsable_banktrack.pdf',
    },
    VERIFACTU_DOCS: {
        ES: 'https://docs.banktrack.com/es/articles/14774569-como-configurar-verifactu-en-banktrack',
        EN: 'https://docs.banktrack.com/es/articles/14774569-como-configurar-verifactu-en-banktrack',
    },
    VERIFACTU_OVERVIEW: {
        ES: 'https://docs.banktrack.com/es/articles/14774572-verifactu',
        EN: 'https://docs.banktrack.com/es/articles/14774572-verifactu',
    },
    TAXES_TYPES: {
        ES: 'https://docs.banktrack.com/es/articles/15014191-guia-de-tipos-de-impuestos',
        EN: 'https://docs.banktrack.com/es/articles/15014191-guia-de-tipos-de-impuestos',
    },
    BANK_OUTAGES: {
        ES: 'https://docs.banktrack.com/es/articles/17600790-que-hacer-cuando-un-banco-esta-caido',
        EN: 'https://docs.banktrack.com/es/articles/17600790-que-hacer-cuando-un-banco-esta-caido',
    },
};

export const PAYMENT_METHODS_TYPES = {
    CASH: 'cash',
    BANK_DIRECT_DEBIT: 'bank_direct_debit',
    BANK_TRANSFER: 'bank_transfer',
    CREDIT_CARD: 'credit_card',
    FACTORING: 'factoring',
    PAYPAL: 'paypal',
    BIZUM: 'bizum',
    CHECK: 'check',
    OTHER: 'other',
};

export const INVOICE_STATUS = {
    PENDING_VALIDATION: 'pending_validation',
    DRAFTED: 'drafted',
    WITH_ERRORS: 'with_errors',
    OK: 'ok',
    RECONCILABLE: 'reconcilable',
};

export const IVA_TAX_ID = 'th8ZIRpvmVJlr';
export const INITIAL_INVOICE_TAXES_IDS = [IVA_TAX_ID];

export const EXPECTED_API_ERRORS = [
    'requires_redirection',
    'requires_widget',
    'requires_paid_subscription',
    'in_maintenance',
    'no_workspaces_available',
];
